import { useQuery } from '@tanstack/react-query';
import type { AppConfig, SessionUser } from '../../shared/types';
import { api, ApiError } from './api';

export function useConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: () => api<AppConfig>('/api/config'),
    staleTime: Infinity,
  });
}

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return (await api<{ user: SessionUser }>('/api/auth/me')).user;
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 5 * 60_000,
  });
}

export const isAgencyUser = (user: SessionUser | null | undefined) =>
  user?.role === 'admin' || user?.role === 'member';
